/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * NOT_IN operator looks for values that are not in the given list of values.
 */
export interface NotInSubjectId {
    /** The values to compare against. */
    values: string[];
}
